import { render, staticRenderFns } from "./_how-to-choose-right-platform-2026.vue?vue&type=template&id=4b027e72&scoped=true&lang=pug&"
import script from "./_how-to-choose-right-platform-2026.vue?vue&type=script&lang=js&"
export * from "./_how-to-choose-right-platform-2026.vue?vue&type=script&lang=js&"
import style0 from "./_how-to-choose-right-platform-2026.vue?vue&type=style&index=0&id=4b027e72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b027e72",
  null
  
)

export default component.exports